var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59028 10.2972C7.82342 11.7123 5.23713 11.6009 3.59927 9.96302C1.84191 8.20569 1.84191 5.35645 3.59927 3.59909C5.35663 1.84173 8.20588 1.84173 9.96322 3.59909C11.6011 5.23694 11.7125 7.82322 10.2973 9.59009L13.7345 13.0272C13.9297 13.2224 13.9297 13.539 13.7345 13.7343C13.5392 13.9296 13.2226 13.9296 13.0273 13.7343L9.59028 10.2972ZM4.30638 9.25595C2.93954 7.88909 2.93954 5.67303 4.30638 4.30619C5.67322 2.93936 7.88928 2.93936 9.25615 4.30619C10.6219 5.67203 10.6229 7.88582 9.25915 9.25295C9.25815 9.25395 9.25715 9.25489 9.25608 9.25595C9.25508 9.25695 9.25408 9.25795 9.25315 9.25895C7.88602 10.6228 5.67221 10.6218 4.30638 9.25595Z",
    fill: "#979A9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4d7b6d800b1c426021ba72be67c72dd3.svg";
export { ForwardRef as ReactComponent };